<p>modal-declare-rejection-reason works!</p>
